import api from '../api';

export const dispatchMessages = (messages) => ({
	type: 'MESSAGES',
	payload: messages
});

export const dispatchBanners = (banners) => ({
	type: 'BANNERS',
	payload: banners
});

export const getMessages = () => dispatch => {
	return api.getTranslate().then((response) => {
		const upcomingEventsList = response['data'];
		dispatch(dispatchMessages(upcomingEventsList));
	});
}

export const getBanners = () => dispatch => {
	return api.getBanners().then((response) => {
		const banners = response['data'];
		dispatch(dispatchBanners(banners));
	});
}




// WEBPACK FOOTER //
// ./actions/messageActions.js